import { PortalManagementFormValues, PortalConfig } from '../types';
import { PortalConfiguration } from 'modules/portalConfigurations/types';

export const getConfigToSave = (
  portalConfiguration: PortalConfiguration<PortalConfig>,
  formData: PortalManagementFormValues
): PortalConfiguration<PortalConfig> => {
  const config: PortalConfig = {
    allowSyndication: formData.allowSyndication,
    allowLMS: formData.allowLMS,
  };

  return {
    ...portalConfiguration,
    jsonDefinition: { config },
  };
};
